import React, { useState } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  TextField,
  Grid,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import inviteActions from "./actions";
import { useSelector } from "react-redux";
import { UserRole, UserRoleText } from "components/User/constants";
import { INVITE_PROP } from "./constants";
const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const InvitesFilterBar = () => {
  const classes = useStyles();
  const { search } = useSelector((state) => state.invites.table);
  const [role, setRole] = useState("ALL");
  const { setFilter, setSearch, setPageOffset } = inviteActions();
  const matches = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  return (
    <Grid container>
      <Grid
        item
        container
        justify="flex-start"
        alignContent="center"
        xs={12}
        lg={7}
      >
        <FormControl variant="outlined" className={classes.formControl}>
          <TextField
            size="small"
            variant="outlined"
            placeholder="Search"
            value={search}
            onChange={(e) => {
              setPageOffset(0);
              setSearch(e.target.value);
            }}
          />
        </FormControl>
      </Grid>
      {matches && <Grid item lg={1} />}
      <Grid
        item
        container
        justify="flex-start"
        alignContent="center"
        xs={8}
        lg={4}
      >
        <FormControl
          size="small"
          variant="outlined"
          className={classes.formControl}
        >
          <Select
            className={classes.formControl}
            value={role}
            onChange={(e) => {
              if (e.target.value !== "ALL") {
                setFilter([
                  {
                    col: INVITE_PROP.ROLE,
                    op: "eq",
                    val: e.target.value,
                  },
                ]);
              } else {
                setFilter([]);
              }
              setPageOffset(0);
              setRole(e.target.value);
            }}
            autoWidth
          >
            {Object.keys(UserRole).map((x) => {
              return (
                <MenuItem value={UserRole[x]} key={x}>
                  {UserRoleText[UserRole[x]]}
                </MenuItem>
              );
            })}
            <MenuItem value="ALL" key="ALL">
              All
            </MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default InvitesFilterBar;
